export default "__VITE_ASSET__HKQqUZOD__"